import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  appInsights: ApplicationInsights;
  constructor() {
  }

  public setAppInsights(instrumentationKey: string): void {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey,
        enableAutoRouteTracking: true
      }
    });
    this.appInsights.loadAppInsights();
  }

  public logPageView(name?: string, url?: string): void {
    this.appInsights.trackPageView({
      name,
      uri: url
    });
  }

  public logEvent(name: string, properties?: { [key: string]: any }): void {
    this.appInsights.trackEvent({ name}, properties);
  }

  public logMetric(name: string, average: number, properties?: { [key: string]: any }): void {
    this.appInsights.trackMetric({ name, average }, properties);
  }

  public logException(exception: Error, severityLevel?: number): void {
    console.error('error', exception);
    this.appInsights.trackException({ exception, severityLevel });
  }

  public logTrace(message: string, properties?: { [key: string]: any }): void {
    console.error('error', message);
    this.appInsights.trackTrace({ message}, properties);
  }
}
